import React, { useState, useEffect } from "react";
// componentes
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
} from "reactstrap";
import ModalNewFeed from "./ModalNewFeed";
import ModalEdidFeed from "./ModalEditFeed";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import Pagination from "../../../components/Paginationv3";
import WaitExport from "../../../components/WaitExport";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// redux
import { connect } from "react-redux";
// rotas
import { useLocation } from "react-router-dom";
// services
import { getFeed, disableAllPosts } from "../../../utils/services/feed";
// utils
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";

function Feed(props) {
  const { dashFeed = false } = props;
  const location = useLocation();

  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewFeed, setModalNewFeed] = useState(false);
  const [modalEditFeed, setModalEditFeed] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  //deletar evento
  const [successDlg, setSuccessDlg] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [errorOnDeleteAll, setErrorOnDeleteAll] = useState(false);
  //editar feed
  const [feedEdit, setFeedEdit] = useState();
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  //state de feed
  const [feed, setFeed] = useState([]);
  const [countData, setCountData] = useState(1);

  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);
  const [activeFilter, setActiveFilter] = useState("user");
  const debouncedSearch = useDebounce(search, 300);

  const columnsFilter = [
    { name: "Usuário", value: "user", type: "text" },
    { name: "Texto", value: "texto", type: "text" },
    { name: "Criado Em", value: "date", type: "date" },
  ];

  // atualiza o filtro ativo e limpa a busca
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte a data de dd/mm/yyyy para o formato aceito pela API (yyyy-mm-dd)
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // aplica o tratamento de busca conforme o tipo da coluna filtrada (data ou texto)
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // abre/fecha o modal de criar post
  function toggleNewFeed() {
    setModalNewFeed(!modalNewFeed);
  }

  // abre/fecha o modal de editar post
  function toggleEditFeed() {
    setModalEditFeed(!modalEditFeed);
  }

  // busca os posts do feed paginados
  const getAllFeed = async () => {
    setLoading(true);
    try {
      const formData = await getFeed({
        jwt: props.state.global_user_data.data.token,
        idEvent: location.state.idEvent,
        offset: currentIndex > 0 ? currentIndex : 1,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
      });

      if (formData.message && formData.message === "findPostByEvent") {
        setCountData(formData.findPostsData.count);
        setFeed(formData.findPostsData.data);
      }
    } catch (error) {
      console.error("Erro ao buscar posts do feed:", error);
      toast.error("Erro ao buscar posts do feed.");
    } finally {
      setLoading(false);
    }
  };

  // formata a data do post para dd/mm/yyyy - hh:mm
  function formatData(startDate) {
    const data = new Date(startDate);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    const hour = String(data.getHours()).padStart(2, "0");
    const min = String(data.getMinutes()).padStart(2, "0");
    const dataAtual = dia + "/" + mes + "/" + ano + " - " + hour + ":" + min;

    return dataAtual;
  }

  // dispara a geração do xlsx e mostra o indicador de exportação em progresso
  function handleExportPosts() {
    createXlsx({
      jwt: props.state.global_user_data.data.token,
      idEvent: location.state.idEvent,
      limit: 500,
      search: search,
      countData,
      setFinishExport,
    });
    setExportInProgress(true);
  }

  // deleta todos os posts do feed
  async function confirmDeleteAllPosts() {
    try {
      await disableAllPosts({
        jwt: props.state.global_user_data.data.token,
        eventId: location.state.idEvent,
      });

      setDynamicTitle("Sucesso");
      setDynamicDescription("Posts deletados com sucesso");
      setErrorOnDeleteAll(false);
      setSuccessDlg(true);
    } catch (error) {
      console.error("Erro ao deletar os posts:", error);
      setDynamicTitle("Erro");
      setDynamicDescription("Erro ao deletar os posts.");
      setErrorOnDeleteAll(true);
      setSuccessDlg(true);
    }
  }

  useEffect(() => {
    getAllFeed();
  }, [currentIndex, itemsPerPage, debouncedSearch, activeFilter]);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Posts"
          onConfirm={confirmDeleteAllPosts}
        />
      )}

      {modalNewFeed && (
        <ModalNewFeed
          isOpen={modalNewFeed}
          toggle={toggleNewFeed}
          idEvent={location.state.idEvent}
          getAllFeed={getAllFeed}
        />
      )}
      {modalEditFeed && (
        <ModalEdidFeed
          isOpen={modalEditFeed}
          toggle={toggleEditFeed}
          feedEdit={feedEdit}
          idEvent={location.state.idEvent}
          getAllFeed={getAllFeed}
        />
      )}

      {successDlg ? (
        <SweetAlert
          success={!errorOnDeleteAll}
          error={errorOnDeleteAll}
          title={dynamicTitle}
          onConfirm={() => {
            getAllFeed();
            setSuccessDlg(false);
          }}
        >
          {dynamicDescription}
        </SweetAlert>
      ) : null}
      <WaitExport
        isOpen={exportInProgress}
        name="Feed"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <Card>
        <CardBody>
          <CardTitle>Feed</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={activeFilter === "date" ? "date" : "text"}
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={activeFilter === "date" ? "date" : "text"}
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                {feed?.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div onClick={handleExportPosts}>Exportar Posts</div>
                  </Row>
                )}
                {!props.reportToDashboard && (
                  <ActionButtonRounded
                    title="Criar Post"
                    onClick={() => setModalNewFeed(true)}
                    type="mobile"
                  />
                )}
              </Collapse>
            </div>
            <div className="header-btns-container">
              {feed?.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add-lg"
                  onClick={handleExportPosts}
                >
                  Exportar Posts
                </Button>
              )}
              {!props.reportToDashboard && (
                <ActionButtonRounded
                  title="Criar Post"
                  onClick={() => setModalNewFeed(true)}
                  margin={"0 0 0 5px"}
                />
              )}
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Usuário</th>
                  <th>Texto</th>
                  <th>Visível</th>
                  <th>Fixado</th>
                  <th>Criado Em</th>
                  {!dashFeed && <th>Ações</th>}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={6} />
                ) : (
                  feed.map((e) => (
                    <tr key={e.id}>
                      <td>
                        {e.loginid !== null
                          ? e.loginid?.nome
                          : e.loginadmin_id?.nome + " (Admin)"}
                      </td>
                      <td>{e.text}</td>
                      <td>{e.active ? "Sim" : "Não"}</td>
                      <td>{e.fixed ? "Sim" : "Não"}</td>
                      <td>{formatData(e.date)}</td>
                      {!dashFeed && (
                        <td>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setFeedEdit(e);
                              setModalEditFeed(true);
                            }}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      {!props.reportToDashboard ? (
        <div
          className="bottom-navigation"
          style={{
            justifyContent: `${
              feed?.length > 0 && showDeleteAll ? "space-between" : "end"
            }`,
          }}
        >
          {feed?.length > 0 && (
            <ActionButtonRounded
              onClick={() => setModalDeleteAll(true)}
              title="Limpar Todos Posts"
              action="D"
              color="danger"
              setShow={setShowDeleteAll}
              verifyShow={true}
              className="btn-rounded waves-effect waves-light events-button-add-lg"
            />
          )}
          {/*
          Fornecer os 8 parametros obrigatórios;
          ** data - a array contendo as informações da tabela
          ** search - o state do termo de pesquisa
          ** currentIndex - posição atual do index
          ** setCurrentIndex - função para atualizar a posição atual do index
          ** countData - quantidade total de itens
          ** maxItemPerPage - estado quantidade de de itens por página
          ** setMaxItemPerPage - função que troca o estado com a quantidade maxima de itens por página
          ** maxPageButtonsToShow - quantidade de botões qua vão aparecer para a pessoa clicar, somente números impares
          ** 5 = vai de 1 até 5 / 7 vai de 1 até 7
          */}
          <Pagination
            data={feed}
            search={search}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            countData={countData}
            maxItemPerPage={itemsPerPage}
            setMaxItemPerPage={setItemsPerPage}
            maxPageButtonsToShow={3}
          />
        </div>
      ) : (
        <Pagination
          data={feed}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Feed);
